const API_URL = process.env.REACT_APP_API_URL || 'https://geroiyar.yarcloud.ru';

export const RulesService = {
  
  async fetchRules() {
    try {
      const response = await fetch(API_URL+'/api/rules/');
      if (!response.ok) throw new Error('Ошибка загрузки правил');
      const { data } = await response.json();
      return data;
    } catch (error) {
      throw new Error('Не удалось загрузить правила: ' + error.message);
    }
  }
}